<script setup>
  import { useLocale } from 'vuetify'
  const { t } = useLocale()
</script>
<template>
    <div class="w-100">
        <v-combobox
            ref="placeAutocomplete"
            autocomplete="off"
            :label="`${t(label)} *`"
            :id="t(label)"
            :title="t(label)"
            :no-filter="true"
            :rules="[rules.required, validateSelection]"
            menu-icon=""
            :no-data-text="label"
            variant="solo-filled"
            @update:search="getPredictions"
            @update:model-value="validatePlace"
            @update:focused="setFirstPred"
            @blur="validatePlace(place)"
            :disabled="loading"
            class="bg-search font-weight-bold"
            v-model="place"
            hide-details
            return-object 
            item-title="description"
            clearable
            @click:clear="setNull"
            :items="predictions">
        </v-combobox>
    </div>
</template>
<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
    props:{
        preValue:{
            type: Object,
            required: null,
            default: null
        },
        label:{
            type: String,
            required: false,
            default: "location"
        },
        selfUpdateLocation:{
            type: Boolean,
            default: false
        },
        allCountries: {
            type: Boolean,
            default: false
        }
    },
    computed: {
       ...mapGetters({
             loading: 'loading/loading',
         }),
    },
    data: () => ({
        rules:{
            required: value => !!value || 'attributes.generic.validation.required',
        },
        predictions: [],
        place: null,
        pred: 0,
        mapsUrl: null,
        language: localStorage.getItem('locale'),
        avaiableCountries: ['IT','DE','AT','CH'],
    }),
    mounted(){
        this.mapsUrl = this.$env.VITE_GOOGLE_MAPS_API_URL
        // if ("geolocation" in navigator) {
        // /* geolocation is available */
        //     console.log("HAS geolocation")
        //     navigator.geolocation.getCurrentPosition((position) => {
        //         this.getAddress(position.coords.latitude, position.coords.longitude);
        //     });
        // }
        this.rules = {
            required: value => !!value || this.$vuetify.locale.t('attributes.generic.validation.required'),
        }

        if(this.preValue){
            if(this.preValue.description){
                this.predictions = [this.preValue];
                this.place = this.preValue;
            }
        }
        if(this.selfUpdateLocation){
            this.getPredictions(this.preValue.description, true);
        }
        
    },
    methods:{
        setFirstPred(){
            if(this.predictions.length >= 1){
                this.place = this.predictions[0]
                this.getLatLog(this.place)
            }
        },
        async getPredictions(text, autoselect=false){
            
            if(text && text.length > 2){
                // in attesa delle country disponibili (Max 5 o senza filtro https://developers.google.com/maps/documentation/places/web-service/autocomplete?hl=it#components
                //se si vuole aggiungere solo 5 country "&components=country:it|country:ch|country:de|country:fr|country:es"
                let components = this.allCountries ? '' : '&components=country:it|country:ch|country:de|country:fr|country:es'
                let url = `${this.mapsUrl}/place/autocomplete/json?input=${text}&inputtype=textquery&language=${this.language}&types=(cities)${components}&key=${this.$env.VITE_GOOGLE_MAPS_API_KEY}`
                let config = {
                    url,
                    methods: "get",
                    headers: {
                        "Access-Control-Allow-Origin": true
                    }
                }
                let resp = await axios.request(config)
                    .then(function (response) {
                    return response.data;
                });
                this.predictions = resp.predictions;
                if(autoselect){
                    this.place = resp.predictions[0];
                    this.getLatLog(this.place)
                }
            }
            
        },
        async getLatLog(address){

            let newlocation = {
                loc: null,
                cou: null,
                lat: null,
                lon: null,
            }


            if(address){        
                let url = this.mapsUrl+"/geocode/json?sensor=false&address="+address.description+"&language="+this.locale+"&key="+this.$env.VITE_GOOGLE_MAPS_API_KEY

                let config = {
                    url,
                    methods: "get",
                }

                let resp = await axios.request(config)
                    .then(function (response) {
                    return response.data;
                });

                if(resp.results[0]){
                    let geo = resp.results[0]            
                    let country = this.searchCountry( geo.address_components );
                
                    newlocation = {
                        loc: address.place_id,
                        cou: country,
                        lat: geo.geometry.location.lat,
                        lon: geo.geometry.location.lng,
                        description: address.description
                    }
                    this.update(newlocation)
                }
            }

        },
        async getAddress(lat, lon){
        
            let url = this.mapsUrl+"/geocode/json?sensor=false&latlng="+lat+","+lon+"&key="+this.$env.VITE_GOOGLE_MAPS_API_KEY

            let config = {
                url,
                methods: "get",
            }

            let resp = await axios.request(config)
                .then(function (response) {
                    // handle success
                return response.data;
            });

            let geo = resp.results[0]

            let country = this.searchCountry( geo.address_components );

            this.place = geo.formatted_address

            let newlocation = {
                loc: geo.place_id,
                cou: country,
                lat: geo.geometry.location.lat,
                lon: geo.geometry.location.lng,
                description: geo.formatted_address
            }

            this.update(newlocation)

        
        },
        searchCountry(components){
            let country = "IT";
            components.forEach(element => {
                if(element.types.includes('country')){
                    country = element.short_name
                }
            });

            if(!this.avaiableCountries.includes(country)){
                console.log("COUNTRY NOT AVAIBLE "+country);
            }

            return country;
        },
        update(newlocation){
            this.$emit('update',newlocation)
        },
        validatePlace(value) {
            const isValid = this.predictions.some(prediction => prediction.description === value.description);
            if (!isValid) {
                this.place = null;
                this.$emit('update', null);
            }
        },
        validateSelection(value) {
            return !!value || this.$vuetify.locale.t('attributes.generic.validation.required');
        },
        setNull(){
            this.predictions = [];
            this.place = null;
            this.$emit('update',null)
        }
    }
}

</script>

<style scoped>

.bg-search{
    background-color: rgba(255, 255, 255, 0);
    backdrop-filter: blur(5px);
}

</style>